import type React from 'react';

// Icon
import IconCheckmarkWhite from 'images/icons/checkmark-white.svg';

// Misc / utils
import * as S from './styles';

interface CheckboxProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type' | 'onChange'> {
  className?: string;
  ariaLabel?: string;
  children?: React.ReactNode;
  flex?: boolean;
  isChecked: boolean;
  isDisabled?: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const Checkbox: React.FC<CheckboxProps> = ({
  ariaLabel,
  className,
  children,
  flex = false,
  isChecked,
  isDisabled = false,
  onChange,
  ...rest
}) => {
  return (
    <S.Label flex={flex} className={className}>
      <S.HiddenCheckbox
        type="checkbox"
        checked={isChecked}
        disabled={isDisabled}
        onChange={onChange}
        aria-label={ariaLabel}
        {...rest}
      />
      <S.StyledCheckbox checked={isChecked} disabled={isDisabled} aria-disabled>
        {isChecked && <img src={IconCheckmarkWhite} height="14px" width="14px" alt="" />}
      </S.StyledCheckbox>
      {children}
    </S.Label>
  );
};

export default Checkbox;
